<template>
    <BreadCrumb PageTitle="Fiche Produit" />
    <FicheProduit />
</template>

<script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import FicheProduit from "../../components/Etats/FicheProduit.vue";

    export default defineComponent({
        name: "FicheProduitPage",
        components: {
            BreadCrumb,
            FicheProduit,
        },
    });
</script>